<template>
  <div class="bg_gray">
    <top-header :type="6" :hasBorder="true" :placeholder="'销售进度'" :bgColor="'#fff'" fontSize="0.32rem" />
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <div class="no_data" v-if="!list.length">
          <img src="@/assets/img/nodata.png" alt="">
        </div>
        <div class="inner bor_b" v-for="(item, index) in list" :key="index">
          <div class="row">
            <h5>小区楼号：{{item.buildingName ? item.buildingName : '-'}}</h5>
          </div>
          <div class="row m_flex_box flex_vc">
            <p>入网套数：{{item.rwzts ? item.rwzts : '-'}}</p>
            <p>可售套数：{{item.kxsts ? item.kxsts : '-'}}</p>
          </div>
          <div class="row m_flex_box flex_vc">
            <p>成交套数：{{item.cjts ? item.cjts : '-'}}</p>
            <p>入网面积：{{item.zmj ? item.zmj : '-'}} m²</p>
          </div>
          <div class="row m_flex_box flex_vc">
            <p>可售面积：{{item.kxsmj ? item.kxsmj : '-'}} m²</p>
            <p>成交面积：{{item.cjmj ? item.cjmj : '-'}} m²</p>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import topHeader from '@/components/header'
import qs from "qs";
export default {
  data() {
    return {
      isLoading: false,
      list: [],
      loading: false,
      finished: false,
      saleItemId:'',
      timer: null,
    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.getRequest();
  },
  methods: {
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.list = [];
      this.onLoad(1);
    },
    onLoad(type) {
      if(!this.timer) {
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        this.$new.post('sale/getSaleBySaleItemId.do', qs.stringify({
          saleItemId: this.saleItemId
        })).then(res => {
          if(type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj)
            this.finished = true;
          }else{
            this.finished = true;
          }
        })
      }
    },

    getRequest(){
      this.saleItemId = this.$route.query.saleItemId;
    }

  }
};
</script>
<style lang="less" scoped>
.bg_gray{
  min-height: 100vh;
  background-color: #f5f5f5;
}
.inner{
  padding: 0.24rem 0.24rem;
  background-color: #fff;
}
.row{
  color: #303030;
  &:last-child{
    padding-bottom: 0;
  }
  padding-bottom: 0.12rem;
  h5{
    margin-bottom: 0.08rem;
    font-size: 0.26rem;
    font-weight: 800;
  }
  p{
    width: 50%;
    font-size: 0.24rem;
  }
}
.bor_b{
  border-bottom: 0.1rem solid #F5F5F5;
}
</style>